import type { Dictionary, GetterClass, MessagesState } from '../../../models'
import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { MESSAGES_CONSTS } from '../../../store/messages/messages.consts'

export class MessagesGetter implements GetterClass {
  static execute(this: void, state: MessagesState, getters: any): Dictionary {
    const messages = CONTAINER.get<Dictionary<Dictionary>>(TYPES.Messages)
    return messages[getters[MESSAGES_CONSTS.getters.locale]]
  }
}
